import { Modal } from 'antd';
import { EditStatusesModalContent } from './EditStatusesModalContent';

interface EditStatusesModalProps {
  open: boolean;
  onCancel: () => void;
  confirmLoading: boolean;
  /** Manage statuses for this space instead of the active route workspace (e.g. All Tasks cross-space view). */
  workspaceId?: number;
}

const EditStatusesModal = ({ open, onCancel, workspaceId }: EditStatusesModalProps) => {
  return (
    <Modal title="Manage Statuses" open={open} onCancel={onCancel} footer={null} width={640} centered>
      <EditStatusesModalContent workspaceId={workspaceId} />
    </Modal>
  );
};

export default EditStatusesModal;
